var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJrlLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 8.32356L5.25 7L7.48337 14L26.25 8.32356Z",
    fill: "#0075CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63334 20.2289C7.62168 20.2289 7.61072 20.2321 7.59906 20.2329C7.44711 19.6942 7.32096 19.244 7.32096 19.244L3.63245 5.67437C3.63881 5.69431 3.64164 5.71345 3.6427 5.73339L3.62856 5.67955C3.62785 5.67636 3.62785 5.67397 3.62644 5.67157C3.52114 5.36093 3.14585 5.18307 2.36843 5.2736C1.58995 5.36412 1.72635 5.68912 1.83201 6.00017L6.91105 20.5352C6.67146 20.7661 6.51633 21.1054 6.51633 21.4895C6.51633 22.1853 7.01635 22.75 7.63334 22.75C8.25033 22.75 8.75 22.1853 8.75 21.4895C8.75 20.7932 8.25033 20.2289 7.63334 20.2289Z",
    fill: "#FF7500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJrlLogoIcon);
export default __webpack_public_path__ + "static/media/jrl-logo-icon.6de51e90358431467748236e38668568.svg";
export { ForwardRef as ReactComponent };